import { AppFormData, FormState } from '../models/FormState'
import { FormActions, SAVE_FORM_DATA, SET_VALID_SECTIONS } from './actions/form.actions'

export function saveFormData(data: AppFormData): FormActions {
  return {
    type: SAVE_FORM_DATA,
    payload: data
  }
}

export function setValidSections(data: boolean[]): FormActions {
  return {
    type: SET_VALID_SECTIONS,
    payload: data
  }
}

export function getFormData(store: { form: FormState }): AppFormData {
  return store.form.data
}

const initialState: FormState = {
  data: {},
  validSections: [false, false, false, false]
}

export default function formReducer(state = initialState, action: FormActions): FormState {
  switch (action.type) {
    case SAVE_FORM_DATA:
      return {
        ...state,
        data: action.payload
      }

    case SET_VALID_SECTIONS:
      return {
        ...state,
        validSections: action.payload
      }

    default:
      return state
  }
}
